import React from "react";
import { ClaroContactList, ClaroSearch } from '@claropay/shared'
import styled from 'styled-components';

import 'onsenui/css/onsenui.css';
import 'onsenui/css/onsen-css-components.css';
import 'onsenui/css/onsenui.css';

import { getShortName } from "./utils"

import * as sdkclaro from '@claro/sdkclaromicrofront';

const Container = styled.div`
  padding: 5% 2% 1% 2%;
  width: 96%;
  height:94%!important;
  background: #fff;
`;

const WrapperSearch = styled.div`
  border: none;
  border-radius: 10px;
  background: #fff;
`;

const WrapperScroll = styled.div`
  overflow-y: scroll;
  height: 90%!important;
  width: 96%;
  position: absolute!important;
  background: #fff;
  height:83%!important;
  overflow-x: hidden;
`;

const WrapperContactList = styled.div`
    background: #fff;
    margin-bottom:1%;
    //border:1px solid #333;
    padding:5px;
`;

const WrapperTitle = styled.div`
  background-color: #fff;
  padding-top: 7%;
  padding-bottom: 2%;
  color: #37474f;
  font-size: 14px;
`;


class ClaroList extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            contacts: [],
            filterContacts: [],
            favoriteContacts: [],
            recentContacts:[],
            isFilter: false,
            isAddedNewContact: false,
            isDeletedContact: false,
            currentContact: [],
            filterState: [],
            favoriteValidateStatus: true,
            filterRecentContacts: [],
            isFiltered: false,
            changeFavorite: true
        }
    }

    componentDidMount() {
    }

    orderContacts = contactsToOrder => {
        const contactsInOrder = contactsToOrder.sort((a, b) => a.fullName.localeCompare(b.fullName));
        return contactsInOrder;
    }

    parseContacts = (contacts) => {
        const parsedContacts = [];
        contacts.forEach((contact) => {
            parsedContacts.push(
                {
                    shortName: (contact && contact.displayName ? getShortName(contact.displayName) : "-"),
                    fullName: contact.displayName,
                    telephoneNumber: contact.mobileNumber,
                    contactId: contact.mobileNumber,
                    isFavorite: contact.isFavorite
                }
            )
        });
        return parsedContacts;
    }

    getContacts = (data) => {
        const { contacts, favoriteContacts } = this.state;
        const parsedContacts = this.parseContacts(data);
        let contactsWithFavorites = [];

        
        if (this.props.favoriteContacts.length == 0) {

            contactsWithFavorites = parsedContacts.map(contact =>
                ({
                    ...contact,
                    isFavorite: false
                }))
        } else {
            contactsWithFavorites = parsedContacts.map(contact =>
                ({
                    ...contact,
                    isFavorite: favoriteContacts.some(i => i.fullName === contact.fullName ? true : false)
                }))

        }

        let orderedContacts = this.orderContacts(contactsWithFavorites);

    
        if (contacts.length !== data.length || this.state.isAddedNewContact || this.state.isDeletedContact) {
            this.setState({
                isAddedNewContact: false,
                isDeletedContact: false
            })
            this.setState({ contacts: orderedContacts, filterState: orderedContacts })

        }
    }

    getRecentContacts = (data) => {

        const { favoriteContacts } = this.state;

        const parseRecentContacts = this.parseContacts(data);

        let recentContactsWithFavorites = [];

        
        if (this.props.favoriteContacts.length == 0) {

            recentContactsWithFavorites = parseRecentContacts.map(contact =>
                ({
                    ...contact,
                    isFavorite: false
                }))
        } else {
            recentContactsWithFavorites = parseRecentContacts.map(contact =>
                ({
                    ...contact,
                    isFavorite: favoriteContacts.some(i => i.fullName === contact.fullName ? true : false)
                }))
        }

        let orderedRecentContacts = this.orderContacts(recentContactsWithFavorites);

        if(
            (
                orderedRecentContacts.length !== this.state.filterRecentContacts.length && 
                !this.state.isFiltered
            ) || 
            (
                this.state.changeFavorite
            ) 
        ){
            this.setState({
                recentContacts: orderedRecentContacts,
                filterRecentContacts: orderedRecentContacts,
                changeFavorite: false
            });
        }
    }

    getFavoriteContacts = (favoriteContactsList, cb) => {
        const { favoriteContacts } = this.state;

        const parsedFavoriteContacts = this.parseContacts(favoriteContactsList)
        const orderedFavoriteContacts = this.orderContacts(parsedFavoriteContacts);
        if (favoriteContacts.length !== favoriteContactsList.length) {
            this.setState({
                favoriteContacts: orderedFavoriteContacts,
                favoriteContactsFiltered: orderedFavoriteContacts,
                changeFavorite: true
            }, () => {
                cb();
            })
        }

        if (
            this.state.favoriteContacts.length == 1 && 
            this.state.favoriteContactsFiltered && 
            this.props.favoriteContacts.length == 1  &&
            this.state.favoriteValidateStatus
        ) {

            if (this.state.favoriteContactsFiltered.length > 0 && this.state.favoriteContactsFiltered[0].fullName == this.state.currentContact.fullName) {
                let { currentContact } = this.state;
                const encontrado = this.state.filterState.filter(function (element) {
                    if (element.telephoneNumber == currentContact.telephoneNumber && element.fullName == currentContact.fullName) {
                        element.isFavorite = true;
                    }
                    return true
                });

                this.setState({ contacts: encontrado, filterState: encontrado, favoriteValidateStatus:false })
            }
        }
    }

    handleItemClick = (data) => {
        let { updateForm } = this.props;
        window.bandera= 3;
        updateForm(data)
    }


    search = (event) => {
        const query = event.target.value.toUpperCase();
        this.filterContacts(query);
    }


    filterOnlyExistContacts = (data) => {
        let contactos = Object.values(this.props.contactsList);

        
        let filter = []
        data.map(
            (recent) => {
                contactos.find( 
                    contacto => {
                        if(contacto.displayName == recent.displayName && contacto.mobileNumber == recent.mobileNumber){
                            filter.push(recent)
                        }
                    }
                )
            }
        )
        return filter;
    }

    filterContacts = (query) => {
        let { contacts } = this.state
        if (!query) {
            this.setState({ 
                filterState: contacts,
                favoriteContactsFiltered: this.state.favoriteContacts,
                filterRecentContacts: this.state.recentContacts
            })
        } else {
            const result = contacts.filter(contact => {
                const { fullName, telephoneNumber } = contact;
                if (fullName.toUpperCase().includes(query) || telephoneNumber.toUpperCase().includes(query)) {
                    return true;
                }
            }).map(filtered => ({ ...filtered })) || [];

            const resultFavorites = this.state.favoriteContacts.filter(contact => {
                const { fullName, telephoneNumber } = contact;
                if (fullName.toUpperCase().includes(query) || telephoneNumber.toUpperCase().includes(query)) {
                    return true;
                }
            }).map(filtered => ({ ...filtered })) || [];

            const resultRecent = this.state.recentContacts.filter(contact => {
                const { fullName, telephoneNumber } = contact;
                if (fullName.toUpperCase().includes(query) || telephoneNumber.toUpperCase().includes(query)) {
                    return true;
                }
            }).map(filtered => ({ ...filtered })) || [];

            this.setState({ 
                filterState: result, 
                favoriteContactsFiltered: resultFavorites,
                filterRecentContacts : resultRecent,
                isFiltered: true

            })
        }
    }

    handleAddFavorite = contact => {
        
        if (contact.isFavorite) {
            this.props.handleDeleteContactFromFavorites(contact, this.props.serviceId);
            return this.setState({
                isDeletedContact: true,
            });
        }
        this.props.handleAddContactToFavorites(contact, this.props.serviceId)

        this.setState({
            isAddedNewContact: true,
            currentContact: contact
        });

        if (this.state.favoriteContacts.length == 1 && this.props.favoriteContacts.length == 0) {
            contact.isFavorite = true;
            this.setState({ favoriteContactsFiltered: [contact], favoriteValidateStatus:true });
        }
    }

    render() {
        const { title, contactsList, favoriteContacts: favoriteContactsProps, recentContacts } = this.props;
        const contactsListItems = Object.values(contactsList);

        let existFavorites = this.filterOnlyExistContacts(favoriteContactsProps);

        if (existFavorites.length === 0) {
            this.getContacts(contactsListItems);
            
            let existRecent = this.filterOnlyExistContacts(recentContacts);
            if(existRecent.length != 0){
                this.getRecentContacts(existRecent);
            } 

        } else {            
            this.getFavoriteContacts(existFavorites, () => {
                this.getContacts(contactsListItems);
                let existRecent = this.filterOnlyExistContacts(recentContacts);
                if(existRecent.length != 0){
                    this.getRecentContacts(recentContacts);
                }
            });
        }
        const { filterState, favoriteContacts, favoriteContactsFiltered } = this.state

        if (this.state.contacts && Object.keys(this.state.contacts).length > 0) {

            return (
                <Container>
                    <WrapperSearch>
                        <ClaroSearch
                            backgroundColor='#fff'
                            width="100%"
                            placeholder="Buscar contactos"
                            boxShadow="0 0 14px 0 rgba(1,32,36, 0.18)"
                            style={{ border: "none!Important" }}
                            onChange={this.search}
                            borderRadius='10px'
                        />
                    </WrapperSearch>
                    <WrapperScroll style={{ marginTop: "6px" }}>
                        {favoriteContacts.length > 0 && favoriteContactsProps.length > 0 &&
                            <WrapperContactList>
                                <WrapperTitle >Favoritos</WrapperTitle>
                                <ClaroContactList
                                    borderRadiusInPx="5px"
                                    contacts={favoriteContactsFiltered}
                                    handleFavoriteClick={this.handleAddFavorite}
                                    handleItemClick={this.handleItemClick}

                                />
                            </WrapperContactList>
                        }
                        {recentContacts.length > 0 &&
                            <WrapperContactList>
                                <WrapperTitle >Recientes</WrapperTitle>
                                <ClaroContactList
                                    borderRadiusInPx="5px"
                                    contacts={this.state.filterRecentContacts}
                                    handleFavoriteClick={this.handleAddFavorite}
                                    handleItemClick={this.handleItemClick}
                                />
                            </WrapperContactList>
                        }
                        <WrapperContactList>
                            <WrapperTitle >{title}</WrapperTitle>
                            <ClaroContactList
                                borderRadiusInPx="5px"
                                handleFavoriteClick={this.handleAddFavorite}
                                contacts={filterState}
                                handleItemClick={this.handleItemClick} />
                        </WrapperContactList>
                    </WrapperScroll>
                </Container>
            )
        } else {
            return null
        }
    }
}


ClaroList.defaultProps = {
    favoriteContactsProps: [],
    favoriteContacts: [],
    recentContacts: []
}

export default ClaroList;